import { defHttp } from 'xmgoing-server';
import GoingUtils from "@/utils/goingUtils";
import {StorageUtils} from "xmgoing-utils";

/**
 * 获取当前用户的空间信息
 */
enum Api {
  saveLayoutConfig = '/go-lcc/portalBoardConfig/saveConfig',
  getLayoutConfig = '/go-lcc/portalBoardConfig/getConfig',
  getAppObjByAppId = '/go-lcc/app/detail',
  //获取空间列表  不需要授权
  GetAppSpaceList = '/go-lcc/pcSpace/getPcSpaceByAppId',
  GetCurAppMenuList = '/pe-portal/lcc/resource/getPageList',
  GetAppObjByTemplateId = '/pe-portal/lcc/resource/listModuleByTemplateId',
  GetPortalDetail= '/go-lcc/menuInfoSettingAct/detail',
  RemoveLayoutConfig= '/go-lcc/portalBoardConfig/removeConfig',
}


/**
 * @description: Get user menu based on id
 */
export const getPortalDetail = (id?:string) => {
  return defHttp.get({ url: Api.GetPortalDetail ,params: { id }});
};


/**
 * @description: Get user menu based on id
 */
export const getCurUserSpace = (appId?:string) => {
  if(GoingUtils.isGroupAdmin(StorageUtils.getSessionItem("loginUserType"))){
    return defHttp.get({ url: '/go-lcc/pcSpacePermission/listGroupSpace' ,params: { appId }});
  }
  if(GoingUtils.isUnitAdmin(StorageUtils.getSessionItem("loginUserType"))){
    return defHttp.get({ url: '/go-lcc/pcSpacePermission/listUnitSpace' ,params: { appId }});
  }

  return defHttp.get({ url: '/go-lcc/pcSpace/getCurUserAclSpaceList' ,params: { appId }});
};

/**
 * 根据appid 获取空间信息
 * @param appId
 */
export const getPcSpaceByAppId = (appId?:string) => {
  return defHttp.get({ url: Api.GetAppSpaceList ,params: { appId }});
};

/**
 * 根据应用id获取应用信息
 * @param appId
 */
export const getAppObjByAppId = (appId?:string) => {
  if((appId+'')==='-1'){
    return ;
  }
  return defHttp.get({ url: Api.getAppObjByAppId ,params: {id:appId }});
};

/**
 * 根据appId 获取对应的应用信息
 * @param appId
 */
export const getAppObjByTemplateId =async (templateId:string) => {
  return defHttp.get({ url: Api.GetAppObjByTemplateId ,params: { templateId }});
};

/**
 * 根据appId 获取对应的应用信息
 * @param appId
 */
export const getAppObjById =async (appId:string) => {
  return defHttp.get({ url: Api.GetCurAppMenuList ,params: { appId }});
};


/**
 * 保存租户的框架的设计信息
 * @description: Get user menu based on id
 */
export const saveLayoutConfig =async (layoutId,configJson) => {
  return defHttp.post({ url: Api.saveLayoutConfig ,params: {boardId:layoutId,configJson }});
};


/**
 * 删除租户的框架设计信息
 */
export const removeMenuAction =async () => {
  return defHttp.post({ url: Api.RemoveLayoutConfig ,params: {}});
};


/**
 * 获取附件配置信息
 */
export const getFileConfigsFromDb = async () => {
  return defHttp.get({url: '/pe-attachment/oss/detail', params: {}});
};
/**
 * 获取应用角色配置信息
 */
export const getRoleAppConfigs= async () => {
  return defHttp.get({url: '/xm-mes/roleAuth/getCurrentAuth', params: {}});
};

/**
 * 获取租户框架的设计信息
 * @param appId
 */
export const getLayoutConfig =async (boardId) => {
  return defHttp.get({ url: Api.getLayoutConfig ,params: { boardId }});
};
